var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FieldInput } from "../../";

var BaseInput = (_temp2 = _class = function (_Component) {
    _inherits(BaseInput, _Component);

    function BaseInput() {
        var _temp, _this, _ret;

        _classCallCheck(this, BaseInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getProps = function () {

            // Note: since React 15.2.0 we can't forward unknown element attributes, so we
            // exclude the "options" and "schema" ones here.
            if (!_this.props.id) {
                console.log("No id for", _this.props);
                throw new Error("no id for props " + JSON.stringify(_this.props));
            }

            var _this$props = _this.props,
                schema = _this$props.schema,
                options = _this$props.options;


            var type = _this.props.type;
            var step = void 0;

            if (options && options.inputType) {
                type = options.inputType;
            }

            if (!type && schema.type === "number") {
                type = "number";
                step = "any";
            }

            if (!type && schema.type === "integer") {
                type = "number";
                step = "1";
            }

            if (!type) {
                type = "text";
            }

            return _extends({}, _this.props, {
                type: type,
                step: step

                /*
                
                const {
                    value,
                    readonly,
                    disabled,
                    autofocus,
                    onBlur,
                    onFocus,
                    options,
                    schema,
                    formContext,
                    registry,
                    rawErrors,
                    ...inputProps
                } = this.props;
                     // If options.inputType is set use that as the input type
                if (options && options.inputType) {
                    inputProps.type = options.inputType;
                } else if (!inputProps.type) {
                    // If the schema is of type number or integer, set the input type to number
                    if (schema.type === "number") {
                        inputProps.type = "number";
                        // Setting step to 'any' fixes a bug in Safari where decimals are not
                        // allowed in number inputs
                        inputProps.step = "any";
                    } else if (schema.type === "integer") {
                        inputProps.type = "number";
                        // Since this is integer, you always want to step up or down in multiples
                        // of 1
                        inputProps.step = "1";
                    } else {
                        inputProps.type = "text";
                    }
                }
                     // If multipleOf is defined, use this as the step value. This mainly improves
                // the experience for keyboard users (who can use the up/down KB arrows).
                if (schema.multipleOf) {
                    inputProps.step = schema.multipleOf;
                }
                
                return inputProps
                
                */

            });
        }, _this.processValue = function (value) {
            var options = _this.props.options;


            if (!value && options && options.emptyValue) {
                value = options.emptyValue;
            }

            return value;
        }, _this.onFocus = function (event) {
            _this.props.onFocus(_this.props.id, _this.processValue(event.target.value));
        }, _this.onBlur = function (event) {
            _this.props.onBlur(_this.props.id, _this.processValue(event.target.value));
        }, _this.onChange = function (value, event) {
            _this.props.onChange(_this.processValue(value));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    BaseInput.prototype.render = function render() {
        var _props = this.props,
            value = _props.value,
            readonly = _props.readonly,
            disabled = _props.disabled,
            autofocus = _props.autofocus;


        var inputProps = this.getProps();

        return React.createElement(FieldInput, _extends({
            value: value == null ? "" : value
        }, inputProps, {
            readonly: readonly,
            disabled: disabled,
            autofocus: autofocus,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus
        }));
    };

    return BaseInput;
}(Component), _class.defaultProps = {
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
}, _temp2);
BaseInput.propTypes = process.env.NODE_ENV !== "production" ? {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
} : {};


export default BaseInput;